// extracted by mini-css-extract-plugin
export default {"buttonPrimary":"ButtonPrimary_buttonPrimary__MQdVM"};